import { useMemo } from 'react';
import { inputSheetAfterCellsChanged } from 'pages/Waterfall/SpreadsheetConfig/InputSheetConfig/InputSheetRowConfig/inputSheetAfterCellsChanged';
import { buildTotalFundInvestmentsExpression } from 'pages/Waterfall/utilities';
import { UseCreateInputSheetProps } from './useCreateInputSheet.props';
import { SpreadsheetConfig } from '../../../../../components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import InputSheetParser from '../InputSheetParser/InputSheetParser';
import inputSheetRowConfig from '../InputSheetRowConfig/inputSheetRowConfig';

const useCreateInputSheet = ({
  exitDate,
  capTableId,
  equityValue,
  enterpriseValue,
  firmOptions,
  childrenCapTables,
  parentCapTables,
  fundInvestmentsSheetsNamesRef,
  plusCashIsFromFinancials,
  lessDebtIsFromFinancials,
  plusCash,
  lessDebt,
  isAdditionalCurrencySelected,
  exchangeRate,
  isExchangeRateOverridden,
  exchangeRateInputCurrency,
  inputScale,
}: UseCreateInputSheetProps) => {
  const exitProceedsExpression = buildTotalFundInvestmentsExpression(fundInvestmentsSheetsNamesRef.current);
  const inputSheetConfig = useMemo(() => {
    if (!exitDate) {
      return null; // Ensure all required fields are provided
    }
    return new SpreadsheetConfig({
      rowConfig: inputSheetRowConfig({
        exitDate,
        capTableId,
        equityValue,
        firmOptions,
        plusCashIsFromFinancials,
        lessDebtIsFromFinancials,
        plusCash,
        lessDebt,
        enterpriseValue,
        childrenCapTables,
        parentCapTables,
        exitProceedsExpression,
        isAdditionalCurrencySelected,
        exchangeRate,
        isExchangeRateOverridden,
        exchangeRateInputCurrency,
        inputScale,
      }),
      //  if currency and additional currency is different, display 3 columns, last one for the additional currency
      columns: isAdditionalCurrencySelected ? [{}, {}, {}] : [{}, {}],
      parser: InputSheetParser,
      afterCellChanged: inputSheetAfterCellsChanged,
      reverseParser: () => ({}) as unknown as SpreadsheetConfig['reverseParser'], // no reverse parsing needed for this page
      showTitlesColumn: false,
      colTitleRow: 0,
      name: 'InputSheet',
      tableTerms: {} as SpreadsheetConfig['tableTerms'],
    });
  }, [
    exitDate,
    capTableId,
    equityValue,
    firmOptions,
    plusCash,
    lessDebt,
    enterpriseValue,
    childrenCapTables,
    parentCapTables,
    exitProceedsExpression,
    isAdditionalCurrencySelected,
    plusCashIsFromFinancials,
    lessDebtIsFromFinancials,
    exchangeRate,
    isExchangeRateOverridden,
    exchangeRateInputCurrency,
    inputScale,
  ]);
  return inputSheetConfig;
};

export default useCreateInputSheet;
